<script setup lang="ts">
const { t } = useI18n();
</script>
<template>
  <div
    class="w-full grid grid-cols-1 xl:grid-cols-2 mt-2 lg:mt-2.5 xl:justify-items-center text-sm lg:text-base text-brand-headline"
  >
    <div class="h-10 lg:h-15.5 flex items-center">
      <i class="m-icon-replacement text-[40px] mr-2.5"></i>
      {{ t("product_page.replacement_under_warranty") }}
    </div>
    <div class="h-10 lg:h-15.5 flex items-center">
      <i class="m-icon-free-delivery text-[40px] mr-2.5"></i>
      {{ t("product_page.free_shipping_over") }}
    </div>
    <div class="h-10 lg:h-15.5 flex items-center xl:col-span-2">
      <i class="m-icon-delivery text-[40px] mr-2.5"></i>
      {{ t("product_in_stock") }}
    </div>
  </div>
</template>
